import React, { Component } from 'react'
import { logoutHandler } from '../actions/sessionActions'
import { connect } from 'react-redux'
import logo from '../assets/images/logo-dark.svg'

export type Callback<T = void> = (...args: any) => T

export interface Props {
  dispatch: Callback
}

export class LogoutView extends Component<Props> {
  static displayName = 'Logout'

  componentDidMount() {
    this.props.dispatch(logoutHandler())
  }

  render() {
    return (
      <div className="row center-xs">
        <div className="col-xs-4 login" data-test="login-container">
          <img src={logo} alt="Blinker" className="login__logo" />
          <h1>GoodBye and thanks for all the fish!</h1>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (store) => {
  return store
}

export const Logout = connect(mapStateToProps)(LogoutView)
